import { gsap } from "gsap";
import BezierEasing from 'bezier-easing';

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import NoScroll from './NoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { CSS } from "../_app/cuchillo/utils/CSS";
import { Basics, isMobile } from "../_app/cuchillo/core/Basics";
import { Maths } from "../_app/cuchillo/utils/Maths";

export default class Works extends NoScroll {
  sliderDom;
  scroller;
  names;

  static sound = new Howl({
      src: ['/assets/audio/tac.mp3'],
      volume: 1,
      preload: true,
      html5: false,
      onload: () => {
        console.log("🎧 Sonido precargado");
      },
      onloaderror: (id, err) => {
        console.error("❌ Error al cargar el sonido", err);
      },
      onend: () => {}
    });

  constructor() {
    super();

    this.sliderDom = GetBy.class('__slider', this.container)[0];
    this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_Y, {
      domResize: this.sliderDom,
      container: this.sliderDom,
      multiplicator: 3,
      itemClass: Project__Item,
      // minSpeed: 4,
      inverted: false,
      gap: 0,
      hasVirtuaScroll: true,
      callback: (__current, __force) => {
        this.viewer.forceLoop(__current, __force);
      }
    });

    this.viewer = new Viewer(GetBy.selector('.__viewer .viewer', this.container)[0]);
    // this.names = GetBy.selector('.__index .name', this.container);
  }

  afterShow() {
    super.afterShow();

    this.scroller.show();
    this.scroller.start();

    this.viewer.show();
  }

  beforeHide() {
    super.beforeHide();
    this.scroller.stop();

    this.viewer.hide();
  }

  loop() {
    super.loop();

    this.scroller.loop();
    this.viewer.loop(this.scroller.actual);
  }

  dispose() {
    this.scroller.dispose();
    this.viewer.dispose();

    super.dispose();
  }

  resize(__w, __h) {
    super.resize(__w, __h);
    this.scroller.resize();
    this.viewer.resize();
  }
}

ControllerPage._addPage('works', Works);

class Project__Item extends InfiniteScroll__Item {
  name;
  nameHeight = 0;
  nameHeightActive = 0;
  anchor;
  easing = BezierEasing(0.420, 0.000, 0.580, 1.000);
  isHover = false;
  siblings;
  cb;
  scroller;
  realIndex = 0;

  _call = {
    hoverIn: e => {

      this.hoverIn(e.target);
    },
    hoverOut: e => {
      this.hoverOut(e.target);
    }
  }

  constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y, __scroller) {
    super(__d, __i, __axis, true);

    this.name = GetBy.selector(".__progress .__index")[this.index];
    this.realIndex = parseInt(this.name.dataset.index);

    this.anchor = GetBy.selector("a", this.name)[0];
    gsap.set(this.anchor, { opacity: 0 });

    this.siblings = __scroller._items;
    this.cb = __scroller._cb;
    this.scroller = __scroller;

    this.addEventListeners();
  }

  show() {
    super.show();

    let i = 0;
    if (this.index >= .4 || this.index <= 4) i = this.index + 4;

    gsap.set(this.anchor, { opacity: 1, delay: .1 * i });
  }

  hide() {
    super.hide();
    gsap.set(this.anchor, { opacity: 0 });
  }

  drawHook() {
    const p = this.progressInside - 1;

    // let t = (this.progressInside) % 1; // va de 0 a 1
    // t = t < 0 ? 1 + t : t;
    // let y = Maths.lerp(this.nameHeight, 0, Math.floor(p) + t * t);

    let y = Maths.lerp(this.nameHeight, 0, p);
    this.name.style[CSS.transform] = CSS.translate3D(0, y, 0);

    if (p < -4.5 || p >= 4.5) {
      this.name.classList.add('--hidden');
    } else {
      this.name.classList.remove('--hidden');
    }

    if (this.isHover) return;

    this.name.classList.remove('--displace-up');
    this.name.classList.remove('--displace-down');
    this.name.classList.remove('--active');

    if (p > -.5 && p <= .5) this.name.classList.add('--active');
    else if (p > 0) this.name.classList.add('--displace-up');
    else if (p < 0) this.name.classList.add('--displace-down');

  }

  addEventListeners() {
    if (!isMobile) {
      this.name.addEventListener(Basics.mouseOver, this._call.hoverIn);
      this.name.addEventListener(Basics.mouseOut, this._call.hoverOut);
    }
  }

  removeEventListeners() {
    if (!isMobile) {
      this.name.removeEventListener(Basics.mouseOver, this._call.hoverIn);
      this.name.removeEventListener(Basics.mouseOut, this._call.hoverOut);
    }
  }

  hoverIn() {
    const p = this.progressInside - 1;

    this.siblings.map(sibling => {
      sibling.isHover = true;

      if (sibling.index === this.index) return;

      sibling.name.classList.remove('--displace-up');
      sibling.name.classList.remove('--displace-down');
      sibling.name.classList.remove('--active');

      const p2 = sibling.progressInside - 1;

      if (p2 > p) sibling.name.classList.add('--displace-up');
      else if (p2 < p) sibling.name.classList.add('--displace-down');
    });

    this.name.classList.remove('--displace-up');
    this.name.classList.remove('--displace-down');
    this.name.classList.add('--active');

    this.cb(this.realIndex, true);
  }

  hoverOut() {
    this.siblings.map(sibling => {
      sibling.isHover = false;
      sibling.drawHook()
    });

    this.cb(this.scroller.actual);
  }

  resize() {
    super.resize();

    if (this.name) {
      this.name.classList.add('--active');
      this.nameHeightActive = this.name.getBoundingClientRect().height;
      this.name.style.setProperty('--height-active', this.nameHeightActive + 'px');
      this.name.classList.remove('--active');

      this.nameHeight = this.name.getBoundingClientRect().height;
      this.name.style.setProperty('--height', this.nameHeight + 'px');
    }
  }

  dispose() {
    super.dispose();
    this.removeEventListeners();
  }
}

class Viewer {
  dom;
  items = [];
  pos = { x: 0, y: 0 };
  dir = { x: 0, y: 0 };
  limits = { x: 0, y: 0 };

  current = -1;
  _forcedCurrent = false;
  _firstSound = true;
  speed = 1;
  tick = 0;

  constructor(__d) {
    this.dom = __d;

    this.items = GetBy.class('__item', this.dom);

    gsap.set(this.dom, { opacity: 0 });
    gsap.set(this.items, { opacity: 0 });

    this.resize();
    this.loop(0);
  }

  show() {
    gsap.set(this.dom, { opacity: 1, delay: .8 });
    gsap.set(this.items[0], { opacity: 1 });
  }

  hide() {
    gsap.set(this.items[this.current], { opacity: 0 });
  }

  loop(c) {
    const newX = this.pos.x = this.pos.x + this.speed * this.dir.x;
    const newY = this.pos.y = this.pos.y + this.speed * this.dir.y;

    if (newX >= this.limits.x - 1 || newX <= 0) this.dir.x *= -1;
    if (newY >= this.limits.y - 1 || newY <= 0) this.dir.y *= -1;

    if (this.tick % 2 === 0) gsap.set(this.dom, { x: newX, y: newY });
    this.tick++;

    if (this._forcedCurrent) return;

    if (this.current !== c) {
      if(!this._firstSound) {
        Works.sound.play();
      }
      this._firstSound = false;
      
      const oldImg = this.items[this.current];
      if (oldImg) {
        gsap.killTweensOf(oldImg);
        gsap.set(oldImg, { opacity: 0 });
      }

      const newImg = this.items[c];
      gsap.killTweensOf(newImg);
      gsap.set(newImg, { opacity: 1 });

      this.current = c;
    }
  }

  forceLoop(__c, __force = false) {
    this.loop(__c);
    this._forcedCurrent = __force;
  }

  resize() {
    const { width, height } = this.dom.getBoundingClientRect();

    this.limits = {
      x: window.innerWidth - width,
      y: window.innerHeight - height
    }

    this.pos = {
      x: window.innerWidth / 2 - width / 2,
      y: window.innerHeight / 2 - height / 2
    };

    this.dir = {
      x: Math.random() <= .5 ? -1 : 1,
      y: Math.random() <= .5 ? -1 : 1
    }
  }
}
